import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getVoiceNonvoiceItems, setSelectedItem } from "../../../actions/uploads.action";



ReactModal.setAppElement('#root')
export function ItemSelectionModalPopup({ isOpen, setShowModal, children }) {
    return (<>
        <ReactModal isOpen={isOpen} shouldCloseOnOverlayClick={true} preventScroll={true}
            onRequestClose={() => setShowModal(false)}
            portalClassName='backdrop'
            style={{
                overlay: {
                    background: ' #63666A66 0% 0% no-repeat padding-box',
                    opacity: '1',
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-30%',
                    transform: 'translate(-50%, -50%)',
                    margin: '20px',
                    padding: '30px',

                }
            }}>
            {children}
        </ReactModal>

    </>)
}


export function ItemSelectionModal(props){
    const history = useHistory();
    const dispatch = useDispatch();
    let voicenonvoiceitems = useSelector((state) => state.uploadReducer.voicenonvoiceitems);
    console.log('voicenonvoiceitems',voicenonvoiceitems)

    useEffect(()=>{
        dispatch(getVoiceNonvoiceItems())
    },[dispatch])

    const [selectedItem, setselectedItem] = useState('');
    const [ItemId, setItemId] = useState('');

   // console.log('selectedItem',selectedItem)
    return(
        <>
            <div className='select_role'>Select Item </div>
            <main className='roles_container'>
                    {voicenonvoiceitems?.map((role,id) =>
                        <div className='role_widget '  key={role.ItemName} >
                            <label htmlFor={id}style={{ cursor: 'pointer' }}>
                                <input className='radio_type' type="radio" id={id} name='rolesSelection' value={role.ItemName} onChange={() =>{ setselectedItem(role);
                                setItemId(role.ItemID)}} style={{ cursor: 'pointer' }} />
                                <span className='label_role' >{role.ItemName}</span></label>
                        </div>)}
                </main>
                <main className="Upload_Buttons_Container">
                            <button type='button' className='btn_adduser' onClick={()=>{history.push('/upload/dataAdmin');dispatch(setSelectedItem(selectedItem))}}>
                                PROCEED
                            </button>
                            <button className='btn_canceluser' onClick={props.handleFileUploadCancel}>
                                CANCEL
                            </button>
                        </main>
        </>
    )

}